module.exports = __webpack_public_path__ + "static/media/login-page-bg.06badc93.jpeg";